module.exports = __webpack_public_path__ + "img/036-bat.7eee0d53.png";